import { Container, Grid } from '@mui/material'
import 'react-dropzone-uploader/dist/styles.css'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { LessonContent, LessonView } from '../../../../shared/styles/CoursesStyles'
import { useLessonsDetail } from '../hooks/useLessonsDetails'
import { LessonInfo } from './LessonsDetail/LessonInfo'
import { LessonNavigation } from './LessonsDetail/LessonNavigation'
import { MultimediaEditDialog } from './LessonsDetail/MultimediaEditDialog'
import { MultimediaSection } from './LessonsDetail/MultimediaSectionProps'

type LessonTemplateProps = {
  lesson: any
  course: any
}

function LessonsDetail({ lesson, course }: LessonTemplateProps) {
  const isMobile = useScreenWidth(700)

  const {
    lessonMultimediaSelected,
    showEditLessonMultimedia,
    currentTab,
    error,
    msg,
    handleChangeLesson,
    handleFinishLesson,
    handleEditMediaFileBlock,
    handleCloseEditLessonMultimedia,
    handleDownloadMediaFileBlock,
    handleDeleteMediaFileBlock,
    handleSubmit,
    handleTabChange,
    getUploadParams,
    isLastLesson,
    isFirstLesson,
    showFinishButton,
    hasVipAccess
  } = useLessonsDetail({ lesson, course })

  return (
    <>
      <LessonView sx={{ my: isMobile ? 2 : 0 }}>
        <LessonContent dangerouslySetInnerHTML={{ __html: lesson.content }} />
      </LessonView>

      <Container maxWidth="md" sx={isMobile ? { padding: 0 } : {}} data-testid="course-lesson-container">
        <Grid container justifyContent="space-between" alignItems="center" spacing={3} sx={{ marginTop: 2 }}>
          <LessonInfo course={course} lesson={lesson} />

          <LessonNavigation
            lesson={lesson}
            course={course}
            isFirstLesson={isFirstLesson}
            isLastLesson={isLastLesson}
            showFinishButton={showFinishButton}
            onChangeLesson={handleChangeLesson}
            onFinishLesson={handleFinishLesson}
          />
        </Grid>

        <MultimediaSection
          lesson={lesson}
          course={course}
          hasVipAccess={hasVipAccess}
          isMobile={isMobile}
          onEdit={handleEditMediaFileBlock}
          onDownload={handleDownloadMediaFileBlock}
          onDelete={handleDeleteMediaFileBlock}
        />
      </Container>

      <MultimediaEditDialog
        open={showEditLessonMultimedia}
        lessonMultimedia={lessonMultimediaSelected}
        currentTab={currentTab}
        onClose={handleCloseEditLessonMultimedia}
        onSubmit={handleSubmit}
        onTabChange={handleTabChange}
        getUploadParams={getUploadParams}
      />

      <CustomSnackBar errors={[error]} msgs={[msg]} />
    </>
  )
}

export default LessonsDetail
